import React from 'react';
import { movdFocus, movdTokens } from './movdTokens.js';

const variants = {
  primary: { background: movdTokens.color.teal, color: movdTokens.color.ink, border: '1px solid transparent' },
  secondary: { background: 'transparent', color: movdTokens.color.text, border: `1px solid rgba(248,250,252,.32)` },
  ghost: { background: 'transparent', color: movdTokens.color.tealSoft, border: '1px solid transparent' },
  warm: { background: movdTokens.color.warm, color: movdTokens.color.ink, border: '1px solid transparent' },
};

export default function MovdButton({ variant = 'primary', loading = false, children, style, ...props }) {
  const tone = variants[variant] || variants.primary;
  return (
    <button
      type="button"
      {...props}
      disabled={props.disabled || loading}
      style={{
        ...tone,
        minHeight: 48,
        padding: '0 20px',
        borderRadius: movdTokens.radius.control,
        font: 'inherit',
        fontSize: 14,
        fontWeight: 850,
        letterSpacing: '.01em',
        cursor: props.disabled || loading ? 'not-allowed' : 'pointer',
        opacity: props.disabled || loading ? .5 : 1,
        transition: `transform ${movdTokens.motion.micro}, background ${movdTokens.motion.micro}, border-color ${movdTokens.motion.micro}`,
        ...style,
      }}
      onFocus={event => {
        event.currentTarget.style.outline = movdFocus.outline;
        event.currentTarget.style.outlineOffset = `${movdFocus.outlineOffset}px`;
        props.onFocus?.(event);
      }}
      onBlur={event => {
        event.currentTarget.style.outline = '';
        props.onBlur?.(event);
      }}
      onMouseDown={event => {
        if (!props.disabled && !loading) event.currentTarget.style.transform = 'translateY(1px)';
        props.onMouseDown?.(event);
      }}
      onMouseUp={event => {
        event.currentTarget.style.transform = '';
        props.onMouseUp?.(event);
      }}
    >
      {loading ? 'Working…' : children}
    </button>
  );
}
